<template>
  <div class="minister-shell">
    <main class="minister-main">
      <header class="minister-header-card">
        <div class="minister-header-card__left">
          <img :src="keralaForestLogo" alt="Kerala Forest Department Logo" class="kfd-emblem" />
          <div class="minister-header-card__titles">
            <div class="header-card-eyebrow">KERALA FOREST DEPARTMENT</div>
            <h1 class="header-card-title">{{ pageTitle }}</h1>
            <div class="header-card-subtitle">{{ pageSubtitle }}</div>
          </div>
        </div>

        <div class="minister-header-card__right">
          <!-- Glowing Live Badge -->
          <div class="live-status-badge">
            <span class="live-status-pulse"></span>
            <span class="live-status-text">LIVE</span>
          </div>

          <!-- Support Agent Icon & Helpline Number -->
          <div class="helpline-group">
            <svg class="helpline-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" stroke="#173824" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M24 8a12 12 0 0 0-12 12v6c0 6.63 5.37 12 12 12s12-5.37 12-12v-6A12 12 0 0 0 24 8z" />
              <circle cx="19" cy="22" r="1.5" fill="#173824" />
              <circle cx="29" cy="22" r="1.5" fill="#173824" />
              <path d="M20 28c2 2 6 2 8 0" />
              <path d="M10 20a14 14 0 0 1 28 0" stroke-width="3.5" />
              <rect x="7" y="17" width="4" height="8" rx="2" fill="#173824" />
              <rect x="37" y="17" width="4" height="8" rx="2" fill="#173824" />
              <path d="M37 23c-1 3-5 5-8 5" />
              <circle cx="28" cy="28" r="1" fill="#173824" />
            </svg>
            <span class="helpline-number">1926</span>
          </div>

          <button class="minister-logout-btn" title="Logout" @click="logout">
            <v-icon size="20" color="#ffffff">mdi-logout</v-icon>
          </button>
        </div>
      </header>

      <section class="minister-body">
        <router-view />
      </section>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import keralaForestLogo from "@/assets/kerala-forest-department-logo.png";

export default {
  data() {
    return {
      keralaForestLogo,
      isSidebarCollapsed: true,
      navItems: [
        { title: "Dashboard", path: "/minister/dashboard", icon: "mdi-view-dashboard-outline" },
        { title: "Map View", path: "/minister/map", icon: "mdi-map-marker-radius-outline" },
      ],
      isMobileLayout: false,
      previousDayLabel: new Date(Date.now() - 86400000).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }),
    };
  },
  computed: {
    pageTitle() {
      if (this.$route.name === "ministerMap") {
        return "Conflict Map Overview";
      } else if (this.$route.name === "ministerIncidents") {
        return "Previous Day Incidents";
      } else if (this.$route.name === "ministerUnassigned") {
        return "Unassigned & Unmapped Incidents";
      } else {
        return "24 x 7 Forest Call Centre Response Dashboard";
      }
    },
    pageSubtitle() {
      if (this.$route.name === "ministerMap") {
        return "State-wide spatial distribution of wildlife conflict and reports";
      } else if (this.$route.name === "ministerIncidents") {
        return "Detailed log of conflict and snake reports";
      } else if (this.$route.name === "ministerUnassigned") {
        return "Data Clean-up & Audit";
      } else {
        return "State-wide live monitoring of wildlife conflict calls, incidents and field response";
      }
    },
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    this.fetchSummaryDate();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    async fetchSummaryDate() {
      try {
        const res = await axios({
          method: "GET",
          url: "/minister/dashboard/summary",
          headers: { "x-auth-token": localStorage.getItem("token") },
        });
        if (res.data && res.data.data && res.data.data.date) {
          this.previousDayLabel = new Date(res.data.data.date).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "long",
            year: "numeric",
          });
        }
      } catch (e) {
        console.error("Failed to load header date in layout", e);
      }
    },
    toggleSidebar() {
      this.isSidebarCollapsed = !this.isSidebarCollapsed;
    },
    handleResize() {
      this.isMobileLayout = window.innerWidth <= 1100;
      if (this.isMobileLayout) {
        this.isSidebarCollapsed = true;
      }
    },
    logout() {
      this.$store.commit("logoutUser", true);
    },
  },
};
</script>

<style scoped>
.minister-shell {
  display: block;
  height: 100vh;
  background: #edf2eb;
  overflow: hidden;
}

.minister-sidebar {
  background: linear-gradient(180deg, #183824 0%, #254b31 100%);
  color: #ffffff;
  padding: 18px 14px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  min-height: 100vh;
}

.minister-sidebar__toggle {
  width: 44px;
  height: 44px;
  border: 0;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.minister-sidebar__toggle:hover {
  background: rgba(255, 255, 255, 0.16);
  transform: translateY(-1px);
}

.minister-shell--collapsed .minister-sidebar__toggle {
  margin: 0 auto;
}

.minister-nav {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.minister-nav__item {
  border: 0;
  border-radius: 14px;
  background: transparent;
  color: rgba(255, 255, 255, 0.82);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  min-height: 50px;
  padding: 12px 14px;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease, transform 0.2s ease;
}

.minister-shell--collapsed .minister-nav__item {
  justify-content: center;
  padding: 12px;
}

.minister-nav__item:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
  transform: translateX(2px);
}

.minister-shell--collapsed .minister-nav__item:hover {
  transform: translateY(-1px);
}

.minister-nav__item--active {
  background: #7eb95f;
  color: #102411;
  font-weight: 700;
}

.minister-nav__item--logout {
  margin-top: 24px;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.82);
}

.minister-nav__item--logout:hover {
  background: rgba(235, 87, 87, 0.16) !important;
  color: #ff8a8a !important;
}

.minister-sidebar__footer {
  margin-top: auto;
  padding: 16px 14px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.06);
}

.minister-sidebar__note {
  font-size: 13px;
  font-weight: 700;
}

.minister-sidebar__note--muted {
  font-weight: 400;
  line-height: 1.5;
  margin-top: 8px;
  color: rgba(255, 255, 255, 0.74);
}

.minister-main {
  min-width: 0;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

/* Minister's Dashboard Header Card styles matching mockup exactly */
.minister-header-card {
  margin: 24px 24px 0 24px;
  background: #ffffff;
  border-radius: 16px;
  padding: 16px 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  flex-shrink: 0;
}

.minister-header-card__left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.kfd-emblem {
  width: 50px;
  height: auto;
  object-fit: contain;
  flex-shrink: 0;
}

.minister-header-card__titles {
  display: flex;
  flex-direction: column;
}

.header-card-eyebrow {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  color: #697b69;
  letter-spacing: 0.08em;
  line-height: 1;
}

.header-card-title {
  font-size: 22px;
  font-weight: 800;
  color: #173824;
  margin-top: 4px;
  margin-bottom: 2px;
  line-height: 1.1;
}

.header-card-subtitle {
  font-size: 11px;
  color: #718171;
  font-weight: 500;
}

.minister-header-card__right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.stacked-badges {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.stacked-badge {
  display: inline-flex;
  align-items: center;
  background: #f4f8f3;
  border: 1px solid rgba(23, 56, 36, 0.08);
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  color: #173824;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
}

.badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 8px;
}

.badge-dot--live {
  background-color: #55b557;
  animation: pulse-badge 1.8s infinite ease-in-out;
}

.helpline-group {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: 8px;
  margin-right: 8px;
}

.helpline-icon {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
}

.helpline-number {
  font-size: 36px;
  font-weight: 800;
  color: #173824;
  line-height: 1;
  letter-spacing: -0.02em;
}


@keyframes pulse-badge {
  0% { transform: scale(0.9); opacity: 0.8; }
  50% { transform: scale(1.2); opacity: 1; }
  100% { transform: scale(0.9); opacity: 0.8; }
}

.minister-logout-btn {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #183824;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.minister-logout-btn:hover {
  background: #254b31;
  transform: translateY(-1px);
}

.minister-body {
  flex: 1;
  min-height: 0;
  padding: 16px 24px 24px 24px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

@media (max-width: 1100px) {
  .minister-shell {
    grid-template-columns: 76px minmax(0, 1fr);
    height: auto;
    min-height: 100vh;
    overflow-y: auto;
  }

  .minister-main {
    height: auto;
    overflow-y: auto;
  }

  .minister-header-card {
    margin: 18px 18px 0 18px;
    padding: 14px 18px;
    flex-direction: column;
    align-items: flex-start;
  }

  .minister-header-card__right {
    width: 100%;
    justify-content: space-between;
    margin-top: 14px;
    flex-wrap: wrap;
    gap: 8px;
  }

  .minister-body {
    padding: 18px;
    height: auto;
    overflow: visible;
  }
}

@media (max-width: 760px) {
  .header-card-title {
    font-size: 18px;
  }
}

.live-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(46, 125, 50, 0.08);
  border: 1px solid rgba(46, 125, 50, 0.22);
  border-radius: 20px;
  padding: 6px 14px;
  box-shadow: 0 4px 12px rgba(46, 125, 50, 0.12), 0 1px 3px rgba(0, 0, 0, 0.05);
  margin-right: 12px;
}

.live-status-pulse {
  width: 9px;
  height: 9px;
  background-color: #2e7d32;
  border-radius: 50%;
  box-shadow: 0 0 0 0 rgba(46, 125, 50, 0.6);
  animation: liveBadgePulse 1.8s infinite;
}

.live-status-text {
  font-family: "Inter", "Poppins", sans-serif;
  font-size: 0.8rem;
  font-weight: 800;
  color: #1b5e20;
  letter-spacing: 1px;
  text-shadow: 0 1px 2px rgba(46, 125, 50, 0.15);
}

@keyframes liveBadgePulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(46, 125, 50, 0.7);
  }
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 10px rgba(46, 125, 50, 0);
  }
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(46, 125, 50, 0);
  }
}
</style>
